import React from "react";
import { Tabs } from "radix-ui";

import type * as WPDS from "../theme";

export type TabsContentProps = {
  children?: React.ReactNode;
  value: string;
  /** Overrides for the input text styles. Padding overrides affect the input container and  */
  css?: WPDS.CSS;
} & Tabs.TabsContentProps;

export const TabsContent = ({
  children,
  value,
  ...props
}: TabsContentProps) => {
  return (
    <Tabs.Content value={value} {...props}>
      {children}
    </Tabs.Content>
  );
};

TabsContent.displayName = "TabsContent";
